<template>
  <page :title="title">
    <v-container fluid grid-list-md>
      <v-card>
        <v-card-text>
          <v-layout row wrap align-center>
            <v-flex xs12 sm4>
              <cal-picker v-model="form.tranDateFrom" :label="labels.tranDateFrom" :data-vv-as="labels.tranDateFrom" data-vv-name="form.tranDateFrom"
                :error-messages="errors.collect('form.tranDateFrom')" v-validate="doValidateTranDateFrom" :max="new Date()"/>
            </v-flex>
            <v-flex xs12 sm4>
              <cal-picker v-model="form.tranDateTo" :label="labels.tranDateTo" :data-vv-as="labels.tranDateTo" data-vv-name="form.tranDateTo"
                :error-messages="errors.collect('form.tranDateTo')" v-validate="doValidateTranDateTo" :max="new Date()"/>
            </v-flex>
            <v-flex xs12 class="ma-0 pa-0" />
            <v-flex xs12 sm4>
              <v-autocomplete :items="accmTypes" v-model="form.accumType" v-validate="'required'" clearable :label="labels.accumType"
                item-text="label" item-value="accmType" data-vv-name="accumType" :error-messages="errors.collect('accumType')" :data-vv-as="labels.accumType"
                @change="accumTypeChanged"/>
            </v-flex>
            <v-flex xs12 class="ma-0 pa-0" />
            <v-flex xs12 sm4>
              <v-text-field :loading="loading" :disabled="!enableBlkGrp" v-model="form.blkGrpFrom" :label="labels.blkGrpFrom" :error-messages="errors.collect('blkGrpFrom')"
                data-vv-name="blkGrpFrom" :data-vv-as="labels.blkGrpFrom" append-icon="mdi-magnify" @click:append="showHelpList('blkGrpFrom')" clearable
                @click:clear="blkGrpChanged" />
            </v-flex>
            <v-flex xs12 sm4>
              <v-text-field :loading="loading" :disabled="!enableBlkGrp" v-model="form.blkGrpTo" :label="labels.blkGrpTo" :error-messages="errors.collect('blkGrpTo')"
                data-vv-name="blkGrpTo" :data-vv-as="labels.blkGrpTo" append-icon="mdi-magnify" @click:append="showHelpList('blkGrpTo')" clearable
                @click:clear="blkGrpChanged" />
            </v-flex>
            <v-flex xs12 class="ma-0 pa-0" />
            <v-flex xs12 sm4>
              <v-text-field :loading="loading" :disabled="!enableBlkSubGrp1" v-model="form.blkSubGrp1From" :label="labels.blkSubGrp1From" :error-messages="errors.collect('blkSubGrp1From')"
                data-vv-name="blkSubGrp1From" :data-vv-as="labels.blkSubGrp1From" append-icon="mdi-magnify" @click:append="showHelpList('blkSubGrp1From')" clearable
                @click:clear="blkSGrp1Changed" />
            </v-flex>
            <v-flex xs12 sm4>
              <v-text-field :loading="loading" :disabled="!enableBlkSubGrp1" v-model="form.blkSubGrp1To" :label="labels.blkSubGrp1To" :error-messages="errors.collect('blkSubGrp1To')"
                data-vv-name="blkSubGrp1To" :data-vv-as="labels.blkSubGrp1To" append-icon="mdi-magnify" @click:append="showHelpList('blkSubGrp1To')" clearable
                @click:clear="blkSGrp1Changed" />
            </v-flex>
            <v-flex xs12 class="ma-0 pa-0" />
            <v-flex xs12 sm4>
              <v-text-field :loading="loading" :disabled="!enableBlkSubGrp2" v-model="form.blkSubGrp2From" :label="labels.blkSubGrp2From" :error-messages="errors.collect('blkSubGrp2From')"
                data-vv-name="blkSubGrp2From" :data-vv-as="labels.blkSubGrp2From" append-icon="mdi-magnify" @click:append="showHelpList('blkSubGrp2From')" clearable
                @click:clear="blkSGrp2Changed" />
            </v-flex>
            <v-flex xs12 sm4>
              <v-text-field :loading="loading" :disabled="!enableBlkSubGrp2" v-model="form.blkSubGrp2To" :label="labels.blkSubGrp2To" :error-messages="errors.collect('blkSubGrp2To')"
                data-vv-name="blkSubGrp2To" :data-vv-as="labels.blkSubGrp2To" append-icon="mdi-magnify" @click:append="showHelpList('blkSubGrp2To')" clearable
                @click:clear="blkSGrp2Changed" />
            </v-flex>
            <v-flex xs12 class="ma-0 pa-0" />
            <v-flex xs12 sm4>
              <v-text-field :loading="loading" :disabled="!enableBlk" v-model="form.blkFrom" :label="labels.blkFrom" :error-messages="errors.collect('blkFrom')"
                data-vv-name="blkFrom" :data-vv-as="labels.blkFrom" append-icon="mdi-magnify" @click:append="showHelpList('blkFrom')" clearable/>
            </v-flex>
            <v-flex xs12 sm4>
              <v-text-field :loading="loading" :disabled="!enableBlk" v-model="form.blkTo" :label="labels.blkTo" :error-messages="errors.collect('blkTo')"
                data-vv-name="blkTo" :data-vv-as="labels.blkTo" append-icon="mdi-magnify" @click:append="showHelpList('blkTo')" clearable/>
            </v-flex>
              <v-flex lg8 sm4>
              <v-text-field :loading="loading" v-model="form.excBlk" :label="labels.excBlk" :error-messages="errors.collect('excBlk')"
                data-vv-name="excBlk" :data-vv-as="labels.excBlk" append-icon="mdi-magnify" @click:append="showHelpList('excBlk')" clearable/>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
      <v-layout row wrap>
        <v-flex lg6 xs12 class="pt-3">
          <v-btn class="mr-2" color="primary" type="submit" :loading="submitting" @click.prevent="doValidate">
            {{labels.export}}
            <v-icon right dark>mdi-file-export</v-icon>
          </v-btn>
          <v-btn-toggle dense mandatory v-model="form.format">
            <v-btn text v-for="format in supportedList" :key="format.value" :value="format.value">
              <span>{{format.label}}</span>
              <v-icon :color="format.color">{{format.icon}}</v-icon>
            </v-btn>
          </v-btn-toggle>
        </v-flex>
        <v-flex lg6 xs12>
          <v-checkbox dense v-model="form.printRptRunTime" :label="labels.printRptRunTime" data-vv-name="printRptRunTime" :data-vv-as="labels.printRptRunTime"></v-checkbox>
        </v-flex>
      </v-layout>
    </v-container>
    <v-dialog v-model="dialogBlkGrp" width="900px" persistent>
      <block-group-help-list v-if="dialogBlkGrp" :accmType="form.accumType" @close="doClose" @assign-blkGrp="doAssign($event)" />
    </v-dialog>
    <v-dialog v-model="dialogBlkSubGrp1" width="900px" persistent>
      <block-sub-group-1-help-list v-if="dialogBlkSubGrp1" :accmType="form.accumType" :blkGrpFrm="form.blkGrpFrom" :blkGrpTo="form.blkGrpTo" @close="doClose"
      @assign-blksGrp1="doAssign($event)"/>
    </v-dialog>
    <v-dialog v-model="dialogBlkSubGrp2" width="900px" persistent>
      <block-sub-group-2-help-list v-if="dialogBlkSubGrp2" :accmType="form.accumType" :blkGrpFrm="form.blkGrpFrom" :blkGrpTo="form.blkGrpTo"
        :blksGrp1Frm="form.blkSubGrp1From" :blksGrp1To="form.blkSubGrp1To" @close="doClose"
        @assign-blksGrp2="doAssign($event)"/>
    </v-dialog>
    <v-dialog v-model="dialogBlk" width="900px" persistent>
    <block-help-list v-if="dialogBlk" :accmType="form.accumType" :blkGrpFrm="form.blkGrpFrom" :blkGrpTo="form.blkGrpTo"
      :blksGrp1Frm="form.blkSubGrp1From" :blksGrp1To="form.blkSubGrp1To" :blksGrp2Frm="form.blkSubGrp2From" :blksGrp2To="form.blkSubGrp2To"
      @close="doClose" @assign-blk="doAssign($event)"/>
    </v-dialog>
    <v-dialog v-model="dialogExcBlk" width="900px" persistent>
      <multi-block-help-list v-if="dialogExcBlk" :accmType="form.accumType" :blkGrpFrm="form.blkGrpFrom" :blkGrpTo="form.blkGrpTo"
        :blksGrp1Frm="form.blkSubGrp1From" :blksGrp1To="form.blkSubGrp1To" :blksGrp2Frm="form.blkSubGrp2From" :blksGrp2To="form.blkSubGrp2To"
        @close="doClose" @doAssign="doAssign($event)"/>
    </v-dialog>
  </page>
</template>
<script>
import BlockGroupHelpList from '@/components/core/common/dialog/BlockGroupHelpList'
import BlockSubGroup1HelpList from '@/components/core/common/dialog/BlockSubGroup1HelpList'
import BlockSubGroup2HelpList from '@/components/core/common/dialog/BlockSubGroup2HelpList'
import BlockHelpList from '@/components/core/common/dialog/BlockHelpList'
import MultiBlockHelpList from '@/components/core/common/dialog/MultiBlockHelpList'
import { reportFormat } from '@/const/report'
import { commonAjaxMixin } from '@/mixins/common/commonAjaxMixin'
import isAfter from 'date-fns/isAfter'
import { removeTime } from '@/utils/date'
export default {
  components: {
    BlockGroupHelpList,
    BlockSubGroup1HelpList,
    BlockSubGroup2HelpList,
    BlockHelpList,
    MultiBlockHelpList
  },
  mixins: [
    commonAjaxMixin
  ],
  data() {
    return {
      title: 'Monthly Surplus Treaty',
      loading: false,
      submitting: false,
      form: {
        action: undefined,
        tranDateFrom: new Date(),
        tranDateTo: new Date(),
        accumType: undefined,
        blkGrpFrom: undefined,
        blkGrpTo: undefined,
        blkSubGrp1From: undefined,
        blkSubGrp1To: undefined,
        blkSubGrp2From: undefined,
        blkSubGrp2To: undefined,
        blkFrom: undefined,
        blkTo: undefined,
        excBlk: undefined,
        printRptRunTime: true
      },
      labels: {
        tranDateFrom: 'Transaction Date From',
        tranDateTo: 'To',
        accumType: 'Accumulation Type',
        blkGrpFrom: 'Block Group From',
        blkGrpTo: 'To',
        blkSubGrp1From: 'Block Sub Group 1 From',
        blkSubGrp1To: 'To',
        blkSubGrp2From: 'Block Sub Group 2 From',
        blkSubGrp2To: 'To',
        blkFrom: 'Block From',
        blkTo: 'To',
        excBlk: 'Exclude Block',
        normalise: 'Normalise',
        export: 'Export to',
        printRptRunTime: 'Print report runtime parameters'
      },
      activeHelpList: false,
      dialogBlkGrp: false,
      dialogBlkSubGrp1: false,
      dialogBlkSubGrp2: false,
      dialogBlk: false,
      dialogExcBlk: false,
      blkSubGrp2s: [],
      blks: [],
      accmTypes: []
    }
  },
  created() {
    this.$validator.extend('valMaxDate', {
      getMessage(field, args) {
        return 'Cannot be later than System Date'
      },
      validate(value, args) {
        let maxDate = args[0]
        if (value) {
          return !isAfter(removeTime(value), removeTime(maxDate))
        } else return true
      }
    })
    this.$validator.extend('valMinDate', {
      getMessage(field, args) {
        return 'Cannot be earlier than From Date'
      },
      validate(value, args) {
        let mixDate = args[0]
        if (value) {
          return !isAfter(removeTime(mixDate), removeTime(value))
        } else return true
      }
    })
  },
  mounted() {
    this.doInit()
  },
  methods: {
    async doInit() {
      if (this.$store.state.reports.uwReports.menu !== 1) {
        await Promise.all([this.$store.dispatch('normTreatySurplusInit')])
      }
      await this.getAccmType()
      if (this.$store.state.blkParam.init !== 1) {
        this.$store.dispatch('blkParamManagementInit')
      }
      this.$store.dispatch('nts_loadAccumTypes')
    },
    accumTypeChanged() {
      this.form.blkGrpFrom = undefined
      this.form.blkGrpTo = undefined
      this.blkGrpChanged()
    },
    blkGrpChanged() {
      this.form.blkSubGrp1From = undefined
      this.form.blkSubGrp1To = undefined
      this.blkSGrp1Changed()
    },
    blkSGrp1Changed() {
      this.form.blkSubGrp2From = undefined
      this.form.blkSubGrp2To = undefined
      this.blkSGrp2Changed()
    },
    blkSGrp2Changed() {
      this.form.blkFrom = undefined
      this.form.blkTo = undefined
    },
    showHelpList(field) {
      this.activeHelpList = field
      if (this.activeHelpList === 'blkGrpFrom' || this.activeHelpList === 'blkGrpTo') {
        this.dialogBlkGrp = true
      } else if (this.activeHelpList === 'blkSubGrp1From' || this.activeHelpList === 'blkSubGrp1To') {
        this.dialogBlkSubGrp1 = true
      } else if (this.activeHelpList === 'blkSubGrp2From' || this.activeHelpList === 'blkSubGrp2To') {
        this.dialogBlkSubGrp2 = true
      } else if (this.activeHelpList === 'blkFrom' || this.activeHelpList === 'blkTo') {
        this.dialogBlk = true
      } else if (this.activeHelpList === 'excBlk') {
        this.dialogExcBlk = true
      }
    },
    doAssign(val) {
      if (this.activeHelpList === 'blkGrpFrom') {
        this.form.blkGrpFrom = val
        this.blkGrpChanged()
      } else if (this.activeHelpList === 'blkGrpTo') {
        this.form.blkGrpTo = val
        this.blkGrpChanged()
      } else if (this.activeHelpList === 'blkSubGrp1From') {
        this.form.blkSubGrp1From = val
        this.blkSGrp1Changed()
      } else if (this.activeHelpList === 'blkSubGrp1To') {
        this.form.blkSubGrp1To = val
        this.blkSGrp1Changed()
      } else if (this.activeHelpList === 'blkSubGrp2From') {
        this.form.blkSubGrp2From = val
        this.blkSGrp2Changed()
      } else if (this.activeHelpList === 'blkSubGrp2To') {
        this.form.blkSubGrp2To = val
        this.blkSGrp2Changed()
      } else if (this.activeHelpList === 'blkFrom') {
        this.form.blkFrom = val
      } else if (this.activeHelpList === 'blkTo') {
        this.form.blkTo = val
      } else if (this.activeHelpList === 'excBlk') {
        this.form.excBlk = val.finalSelectedItems.toString()
      }
      this.activeHelpList = ''
      this.doClose()
    },
    doClose() {
      this.dialogBlkGrp = false
      this.dialogBlkSubGrp1 = false
      this.dialogBlkSubGrp2 = false
      this.dialogBlk = false
      this.dialogExcBlk = false
    },
    doValidate() {
      this.$validator.validateAll().then(result => {
        this.sendRequest()
      })
    },
    async sendRequest() {
      const apiURI = this.menu.export
      if (apiURI) {
        try {
          this.submitting = true
          await this.$http.post(apiURI, this.form)
          this.$toast.success('Report generation started.')
          this.submitting = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.notify(data)
          }
          this.submitting = false
        }
      } else {
        this.errorMessage('The request failed because it is trying to execute an invalid API url.')
      }
    },
    async getAccmType() {
      const apiURI = this.menu.accmType
      if (apiURI) {
        try {
          const result = await this.$http.get(apiURI)
          if (result) {
            const { data } = result.data
            if (data) {
              data.map((accumTypeMap) => {
                const convertList = {
                  label: accumTypeMap.accmType + ' - ' + accumTypeMap.accmTypeDesc,
                  accmType: accumTypeMap.accmType,
                  accmTypeDesc: accumTypeMap.accmTypeDesc,
                  blkGrpLblS: accumTypeMap.blkGrpLblS,
                  blksGrp1LblS: accumTypeMap.blksGrp1LblS,
                  blksGrp2LblS: accumTypeMap.blksGrp2LblS,
                  blkLblS: accumTypeMap.blkLblS
                }
                this.accmTypes.push(convertList)
              })
            }
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.notify(data)
          }
        }
      } else {
        this.errorMessage('The request failed because it is trying to execute an invalid API url.')
      }
    }
  },
  computed: {
    normTreatySurplus() {
      return this.$store.state.normTreatySurplus
    },
    menu() {
      return this.normTreatySurplus.menu
    },
    supportedFormat() {
      return this.normTreatySurplus.supportedFormat || []
    },
    accumTypes() {
      return this.normTreatySurplus.accumTypes
    },
    accumTypeMap() {
      return this.normTreatySurplus.accumTypeMap
    },
    accumType() {
      if (this.form.accumType && this.accumTypeMap[this.form.accumType]) {
        return this.accumTypeMap[this.form.accumType]
      }
      return {}
    },
    enableBlkGrp() {
      if (this.accumType.blkGrpLblS) {
        return true
      }
      return false
    },
    enableBlkSubGrp1() {
      if (this.accumType.blksGrp1LblS) {
        return true
      }
      return false
    },
    enableBlkSubGrp2() {
      if (this.accumType.blksGrp2LblS) {
        return true
      }
      return false
    },
    enableBlk() {
      if (this.accumType.blkLblS) {
        return true
      }
      return false
    },
    doValidateTranDateFrom() {
      const today = new Date()
      return 'required|valMaxDate:' + today
    },
    doValidateTranDateTo() {
      if (this.form.tranDateFrom !== null) {
        return 'required|valMinDate:' + this.form.tranDateFrom
      } else {
        return 'required'
      }
    },
    supportedList() {
      const result = []
      if (this.supportedFormat && this.supportedFormat.length > 0) {
        this.supportedFormat.map(format => {
          if (reportFormat[format]) {
            result.push(reportFormat[format])
          }
        })
      }
      return result
    }
  }
}
</script>
